import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getMisTalentosService } from "../../services/talentos/talentos.service";
import { getConfirmacionStatusThunk } from "../../store/confirmacion/confirmacion.thunks";
import "./talentos-collection.css";

const TalentosCollection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, statusLoading } = useSelector((state) => state.confirmacion);

  const [talentos, setTalentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedCards, setExpandedCards] = useState({});

  useEffect(() => {
    const fetchTalentos = async () => {
      try {
        const data = await getMisTalentosService();
        setTalentos(data);
      } catch (error) {
        // Error al cargar talentos
      } finally {
        setLoading(false);
      }
    };

    fetchTalentos();
  }, []);

  useEffect(() => {
    const loadStatus = async () => {
      try {
        await dispatch(getConfirmacionStatusThunk()).unwrap();
      } catch (error) {
        // Las confirmaciones aún no están disponibles
      }
    };
    loadStatus();
  }, [dispatch]);

  const toggleExpand = (talentoId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [talentoId]: !prev[talentoId],
    }));
  };

  const shouldShowMoreButton = (description) => {
    return description && description.length > 250;
  };

  if (loading) {
    return (
      <div className="talentos-loading">
        <div className="spinner"></div>
        <p>Cargando tus talentos...</p>
      </div>
    );
  }

  const talentosOptimos = talentos?.talentos_optimos || [];
  const talentosAMejorar = talentos?.talentos_a_mejorar || [];

  return (
    <div className="talentos-page">
      <div className="talentos-container">
        {/* Bloque talentos óptimos */}
        <section className="talentos-section talentos-section--optimos">
          <header className="talentos-page-header">
            {/* Botón de confirmación compacto */}
            <button 
              className="confirmacion-btn-compact"
              onClick={() => navigate("/confirmacion-talentos")}
              title="Confirma tus talentos principales respondiendo preguntas específicas"
            >
              <Icon icon="mdi:star-check" />
              <span>
                {status?.todas_completadas 
                  ? "Ver mis resultados" 
                  : status?.talento_nombre 
                    ? "Continuar con la confirmación" 
                    : "Iniciar con la confirmación"}
              </span>
            </button>
            
            <h1 className="page-title">
              Tus autopistas
            </h1>
            <p className="page-subtitle">
              Fortalezas donde hoy destacas más.
            </p>
          </header>

          <section className="talentos-summary">
            <div className="summary-pills">
              {talentosOptimos.map((talento, index) => (
                <div key={talento.talento_id} className="talent-pill talent-pill--optimo">
                  <span className="pill-rank">#{talento.ranking ?? index + 1}</span>
                  <span className="pill-name">{talento.talento_nombre}</span>
                </div>
              ))}
            </div>

           
          </section>

          <section className="talentos-cards-section">
            {talentosOptimos.map((talento) => {
              const isExpanded = expandedCards[talento.talento_id];
              const showButton = shouldShowMoreButton(talento.talento_descripcion);

              return (
                <article key={talento.talento_id} className="talent-card talent-card--optimo">
                  <div className="card-header">
                    <p className="card-chip card-chip--optimo">Talento fuerte</p>
                    <h4 className="card-title">
                      <span className="card-rank">#{talento.ranking}</span> {talento.talento_nombre}
                    </h4>
                  </div>

                  <div className={`card-description ${!isExpanded && showButton ? "truncated" : ""}`}>
                    {talento.talento_descripcion}
                  </div>

                  {showButton && (
                    <div className="card-actions">
                      <button
                        className="expand-btn"
                        onClick={() => toggleExpand(talento.talento_id)}
                      >
                        {isExpanded ? "Ver menos" : "Ver más"}
                      </button>
                    </div>
                  )}
                </article>
              );
            })}
          </section>
        </section>

        {/* Bloque talentos a mejorar */}
        {talentosAMejorar.length > 0 && (
          <section className="talentos-section talentos-section--mejorar">
            <header className="talentos-page-header talentos-page-header--mejorar">
              <h2 className="page-title page-title--mejorar">
               Tus veredas 
              </h2>
              <p className="page-subtitle page-subtitle--mejorar">
                Áreas con menor desarrollo actual que pueden crecer mucho si les das enfoque.
              </p>
            </header>

            <section className="talentos-summary">
              <div className="summary-pills">
                {talentosAMejorar.map((talento, index) => (
                  <div key={talento.talento_id} className="talent-pill talent-pill--mejorar">
                    <span className="pill-rank">#{talento.ranking ?? index + 1}</span>
                    <span className="pill-name">{talento.talento_nombre}</span>
                  </div>
                ))}
              </div>
            </section>

            <section className="talentos-cards-section"> 
              {talentosAMejorar.map((talento) => {
                const isExpanded = expandedCards[talento.talento_id];
                const showButton = shouldShowMoreButton(talento.talento_descripcion);

                return (
                  <article key={talento.talento_id} className="talent-card talent-card--mejorar">
                    <div className="card-header">
                     
                      <h4 className="card-title">
                        {talento.talento_nombre}
                      </h4>
                    </div>

                    <div className={`card-description ${!isExpanded && showButton ? "truncated" : ""}`}>
                      {talento.talento_descripcion}
                    </div>

                    {showButton && (
                      <div className="card-actions">
                        <button
                          className="expand-btn expand-btn--mejorar"
                          onClick={() => toggleExpand(talento.talento_id)}
                        >
                          {isExpanded ? "Ver menos" : "Ver más"}
                        </button>
                      </div>
                    )}
                  </article>
                );
              })}
            </section>
          </section>
        )}
      </div>
    </div>
  );
};

export default TalentosCollection;
